const actions = {
	GET_DROP_DOWN: 'GET_DROP_DOWN',
	GET_DROP_DOWN_SUCCESS: 'GET_DROP_DOWN_SUCCESS',

	CREATE_NEW_DROP_DOWN: 'CREATE_NEW_DROP_DOWN',
	CREATE_NEW_DROP_DOWN_SUCCESS: 'CREATE_NEW_DROP_DOWN_SUCCESS',

	DELETE_DROP_DOWN: 'DELETE_DROP_DOWN',
	DELETE_DROP_DOWN_SUCCESS: 'DELETE_DROP_DOWN_SUCCESS',

	GET_DROP_DOWN_DETAIL: 'GET_DROP_DOWN_DETAIL',
	GET_DROP_DOWN_DETAIL_SUCCESS: 'GET_DROP_DOWN_DETAIL_SUCCESS',

	UPDATE_DROP_DOWN_DETAIL: 'UPDATE_DROP_DOWN_DETAIL',
	UPDATE_DROP_DOWN_DETAIL_SUCCESS: 'UPDATE_DROP_DOWN_DETAIL_SUCCESS',

	READING_LOADING_FALSE: 'READING_LOADING_FALSE',
	//#region CRUD

	getBlanksDropDown: (model) => ({
		type: actions.GET_DROP_DOWN,
		payload: { model },
	}),

	getBlanksDropDownDetail: (id) => ({
		type: actions.GET_DROP_DOWN_DETAIL,
		payload: { id }
	}),

	createBlanksDropDown: (payload, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_DROP_DOWN,
		payload,
		cbSuccess,
		cbError
	}),

	// getReadAloudDetail: (id) => ({
	// 	type: actions.GET_DROP_DOWN_DETAIL,
	// 	payload: { id },
	// }),

	// updateReadAloudDetail: (model, cbSuccess, cbError) => ({
	// 	type: actions.UPDATE_DROP_DOWN_DETAIL,
	// 	payload: { model },
	// 	cbSuccess,
	// 	cbError,
	// }),

	// deleteReadAloud: (id, cbSuccess, cbError) => ({
	// 	type: actions.DELETE_DROP_DOWN,
	// 	payload: { id },
	// 	cbSuccess,
	// 	cbError,
	// }),
};

export default actions;
